<div class="custom-toolbar">
  <div class="custom-toolbar-element custom-toolbar-subdivision-left">
    <yo-lookup
      id="plc-look-up"
      [data]="plcList"
      [selectedItem]="selectedPlc"
      (onValueChange)="updatePlc($event)"
      [showClearButton]="true"
      [width]="250"
      [key]="null"
      enableSearch="true"
      placeholder="Sélectionner un point de livraison"
    >
    </yo-lookup>
  </div>
  <div class="custom-button-container-right">
    <yo-button
      iconClass="fas fa-save"
      buttonClass="cta-success"
      (onClick)="saveEffectivesCommandesClients()"
      [disabled]="isDisabled()"
      tooltip="Enregistrer les effectifs">
    </yo-button>
  </div>
</div>

<dx-toolbar class="p-4">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      <span class="mg-r-5">
        <dx-date-box
          [disabled]="isDatesDisabled()"
          [(value)]="selectedDate"
          [applyValueMode]="'instantly'"
          (onValueChanged)="updateDatesBySelection($event)"
          [calendarOptions]="calendarOptions"
          (onFocusOut)="updtateDatesByClickOutside()"
        >
          <span *dxTemplate="let cell of 'cell'">
            <yo-devextreme-date-dispo [cellData]="cell"
                                      [dateFacturation]="utils.isDateInList(convertToDate(cell.date), datesFacturation)"
                                      [dateSaisieEffectif]="utils.isDateInList(convertToDate(cell.date), datesSaisieEffectifs)"
                                      [dateCreationMenu]="utils.isDateInList(convertToDate(cell.date), datesCreationMenus)"></yo-devextreme-date-dispo>
          </span>
        </dx-date-box>
      </span>
    </div>
  </dxi-item>
</dx-toolbar>

<div class="d-flex mg-t-14 flex-wrap container-table" style="overflow-y: scroll">
  <div class="left">
    <div id="sub-left">
      <yo-generic-prestations-semaine
        [cols]="cols"
        [configPortailPlc]="configPortailPlc">
      </yo-generic-prestations-semaine>
    </div>
    <div class="card-footer mg-t-14">
      <span class="font-weight-normal font-12">
        <div class="text-left">
          <i class="fas fa-square save-color mg-r-5 border"></i>Effectifs en cours de saisie
        </div>
        <div class="text-left">
          <i class="fas fa-square import-color mg-r-5 border"></i>Effectifs importés
        </div>
        <div class="text-left">
          <i class="fas fa-square site-secondaire-color mg-r-5 border"></i>Menus en cours de saisie
        </div>
        <div class="text-left">
          <i class="fas fa-square checked-color mg-r-5 border"></i>Menus validés = Saisie des effectifs possible
        </div>
        <div class="text-left">
          <i class="fas fa-square invoice-color mg-r-5 border"></i>Effectifs faisant l'objet d'une facture
        </div>
        <div class="text-left">
          <i class="fas fa-square white mg-r-5 border"></i>Aucun menu
        </div>
      </span>
    </div>
  </div>
  <div class="right">
    <yo-generic-repas
      [configPortailPlc]="configPortailPlc">
    </yo-generic-repas>
  </div>
</div>

<dx-load-panel
  #loadPanel
  shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
>
</dx-load-panel>
